import { render } from "./ProductFeatures.vue?vue&type=template&id=17959197&scoped=true"
import script from "./ProductFeatures.vue?vue&type=script&lang=js"
export * from "./ProductFeatures.vue?vue&type=script&lang=js"

import "./ProductFeatures.vue?vue&type=style&index=0&id=17959197&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17959197"]])

export default __exports__